module.exports = __webpack_public_path__ + "static/img/4.302f420.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/zh/4.png
// module id = icbe
// module chunks = 0